import type { ReactNode } from 'react';

export interface DocSectionProps {
  /** Section heading (display font, large). */
  title: ReactNode;
  /** Section body content. */
  children: ReactNode;
}

/**
 * Help/docs section wrapper — a display-font heading above prose-like body content.
 * Extracted verbatim from the monolith (legacy/App.tsx); markup unchanged so
 * styling is identical.
 */
export function DocSection({ title, children }: DocSectionProps) {
  return (
    <div className="space-y-4">
      <h2 className="font-display text-2xl font-semibold mb-3">{title}</h2>
      <div className="prose-like space-y-3 text-sm text-ink leading-relaxed">{children}</div>
    </div>
  );
}
